import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'client/environments/environment';
import {
  BlogCategory,
  BlogDetail,
  BlogListQueryParams,
  BlogListResponse,
} from '../blog/blog.models';

@Injectable({ providedIn: 'root' })
export class BlogService {
  private readonly apiBase = (environment.contentApiUrl || '').replace(/\/$/, '');

  constructor(private readonly http: HttpClient) {}

  list(params: BlogListQueryParams = {}): Observable<BlogListResponse> {
    const httpParams = this.createParams(params);
    return this.http
      .get<BlogListResponse>(`${this.apiBase}/api/blogs`, { params: httpParams })
      .pipe(
        map((response) => ({
          items: response?.items ?? [],
          nextCursor: response?.nextCursor ?? null,
        })),
      );
  }

  detail(slug: string): Observable<BlogDetail> {
    return this.http.get<BlogDetail>(`${this.apiBase}/api/blogs/${slug}`).pipe(
      map((detail) => {
        if (!detail) {
          throw new Error('Blog detail not found');
        }
        return detail;
      }),
    );
  }

  categories(): Observable<BlogCategory[]> {
    return this.http
      .get<BlogCategory[]>(`${this.apiBase}/api/blog-categories`)
      .pipe(map((items) => items ?? []));
  }

  private createParams(params: BlogListQueryParams): HttpParams {
    let httpParams = new HttpParams();
    if (params.query) {
      httpParams = httpParams.set('query', params.query);
    }
    if (params.category) {
      httpParams = httpParams.set('category', params.category);
    }
    if (params.cursor) {
      httpParams = httpParams.set('cursor', params.cursor);
    }
    if (typeof params.limit === 'number') {
      httpParams = httpParams.set('limit', String(params.limit));
    }
    if (params.author) {
      httpParams = httpParams.set('author', params.author);
    }
    return httpParams;
  }
}
